export const ITEMS_PER_PAGE = 20;
export const PAGE_SIZE_OPTIONS = [5, 10, 20, 100];
